import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import { callService } from '../../../../../assets/base64Images/ai/callService';
import { updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import OptionButton from '../components/Button/OptionButton';
import { getCabId32Str, getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 安全提示
 */
const Q19: FC<Props> = ({
  cabId,
  addElement,
  h5Platform,
  deviceCode,
  sessionId,
}) => {
  const option = { zhValue: '重新开始', enValue: 'Start over' };
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');

  useEffect(() => {
    // 流程ID
    const flowId = uuid();
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center' }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
            langZh={(
              <>
                这是最后一个柜门，如果这仍旧不是您的外卖订单，请不要取走食物并关闭柜门。 如果您的问题无法解决，请拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> <span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>(工作日 早上 9:00 至下午 5:00)</span>
              </>
            )}
            langEn={(
              <>
                We have opened all the doors for you. If there is not your order, please do not take the food and please close the door. You can call us <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> for human support between <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am - 5:00pm</span>.
              </>
            )}
          />
          <img
            src={callService}
            style={{ width: 41, height: 41, marginLeft: 20 }}
            onClick={() => {
              addSystemLog(cabId, deviceCode, h5Platform + '', 'Q19 - user: call service', sessionId);
              location.href = 'tel:1300359889';
              saveCallLog({
                param: {
                  cabId: getCabId32Str(cabId),
                  telNumber: '1300359889',
                },
              });
            }}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q19 - bot: We have opened all the doors for you. If there is not your order, please do not take the food and please close the door. You can call us 1300 359 889 for human support between Weekdays 9:00am - 5:00pm', sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option.zhValue}
              langEn={option.enValue}
              flowId={flowId}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q19 - user: ' + option.enValue, sessionId);
                addElement([]);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  addElement: (elements: any) => void;
  deviceCode: string;
  h5Platform: number;
  sessionId: string;
}

export default Q19;
